import React, { useEffect, useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";

import {
  agreementMailPages,
  buttonName,
  commonText,
  customersDtls,
  mail,
  ownerTab,
  UserManagment
} from "../../../locales/en";
import { useSearchParams } from "react-router-dom";
import { getOthersOwnerUrl } from "../../../utils/constants/apiEndPoints";
import { showToast } from "../../../utils/utils";
import {
  EMAIL_REGEX_STRICT,
  LETTERS_REGEX_STRICT,
  MAILTO_INFO_EMAIL,
  showToastType
} from "../../../utils/constants/appConstants";
import publicAxios from "../../../utils/publicAxios";

function OtherOwners() {
  const [searchParams] = useSearchParams();
  const [getToken, setToken] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);
  const [owners, setOwners] = useState([
    { firstName: "", lastName: "", email: "" }
  ]);

  const nameRegex = LETTERS_REGEX_STRICT;
  const emailRegex = EMAIL_REGEX_STRICT;

  const [errors, setErrors] = useState([]);

  const validateOwner = (owner) => {
    const errs = {};
    // First Name
    if (!owner.firstName.trim()) errs.firstName = "First name is required.";
    else if (!nameRegex.test(owner.firstName.trim()))
      errs.firstName = "Only letters, spaces, ' and - are allowed.";
    // Last Name
    if (!owner.lastName.trim()) errs.lastName = "Last name is required.";
    else if (!nameRegex.test(owner.lastName.trim()))
      errs.lastName = "Only letters, spaces, ' and - are allowed.";
    // Email
    if (!owner.email.trim()) errs.email = "Email is required.";
    else if (!emailRegex.test(owner.email.trim()))
      errs.email = "Enter a valid email address.";
    return errs;
  };

  const validateAllOwners = (ownersArr) => ownersArr.map(validateOwner);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;

    setOwners((prevOwners) => {
      const updatedOwners = [...prevOwners];
      updatedOwners[index][name] = value;
      return updatedOwners;
    });
  };

  const handleAddOwner = () => {
    setOwners((prevOwners) => [
      ...prevOwners,
      { firstName: "", lastName: "", email: "" }
    ]);

    setErrors((prev) => [...prev, {}]);
  };

  const handleDeleteOwner = (index) => {
    setOwners(owners.filter((_, i) => i !== index));
    setErrors((prev) => prev.filter((_, i) => i !== index));
  };

  const initialSubmitting = false;
  const [submitting, setSubmitting] = useState(initialSubmitting);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const nextErrors = validateAllOwners(owners);
    setErrors(nextErrors);

    const hasErrors = nextErrors.some((er) => Object.keys(er).length > 0);
    if (hasErrors) return; // stop if invalid

    try {
      setSubmitting(true);
      const response = await publicAxios.post(getOthersOwnerUrl, owners, {
        params: { token: getToken }
      });

      if (response.status === 200) {
        showToast(response.data.message, showToastType.success);
        setSuccessMsg(true);
      }
    } catch (error) {
      showToast(error.response.data.message, showToastType.error);
      setSubmitting(false);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const token = searchParams.get("token");
    setToken(token);
  }, [searchParams]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          {successMsg ? (
            <div className="alert alert-success mt-5" role="alert">
              {`${agreementMailPages?.addOwners.successText} `}
              <a href={MAILTO_INFO_EMAIL}>{mail}</a>
            </div>
          ) : (
            <div className="step-wrap">
              <div className="step-title">
                <h3>{agreementMailPages?.addOwners.title}</h3>
              </div>
              <div className="step-content">
                <div className="aplyid-section">
                  <p>{ownerTab.stepContent.idRequirement}</p>
                  <p>{ownerTab.stepContent.addOwnerInstructions}</p>

                  <div className="addowners-wrap mt-4">
                    <div className="addowners-form mt-3">
                      {owners?.map((owner, index) => (
                        <div key={index}>
                          <div className="row mb-3">
                            <div className="col-6 d-flex align-items-center">
                              <div className="owner-title">
                                <h4>
                                  {index + 1}. {customersDtls.tabs.title4}
                                </h4>
                              </div>
                            </div>

                            <div className="col-6">
                              <div className="delete-owner">
                                <button
                                  type="button"
                                  className="delete"
                                  onClick={() => handleDeleteOwner(index)}
                                >
                                  <FaRegTrashAlt />
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label className="py-2">
                                {
                                  UserManagment.ownerTab.identificationSection
                                    .firstName
                                }
                                <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="firstName"
                                  type="text"
                                  value={owner.firstName}
                                  onChange={(e) => handleInputChange(index, e)}
                                />
                                {errors[index]?.firstName && (
                                  <div className="invalid-feedback d-block">
                                    {errors[index].firstName}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label className="py-2">
                                {
                                  UserManagment.ownerTab.identificationSection
                                    .lastName
                                }
                                <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="lastName"
                                  type="text"
                                  value={owner.lastName}
                                  onChange={(e) => handleInputChange(index, e)}
                                />
                                {errors[index]?.lastName && (
                                  <div className="invalid-feedback d-block">
                                    {errors[index].lastName}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="row mb-2">
                            <div className="col-md-6">
                              <label
                                htmlFor={`email-${index}`}
                                className="py-2"
                              >
                                {buttonName.email} <sup>*</sup>
                              </label>
                            </div>
                            <div className="col-md-6">
                              <div className="input-wrap">
                                <input
                                  name="email"
                                  type="email"
                                  id={`email-${index}`}
                                  value={owner.email}
                                  onChange={(e) => handleInputChange(index, e)}
                                />
                                {errors[index]?.email && (
                                  <div className="invalid-feedback d-block">
                                    {errors[index].email}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="row">
                      <div className="col-6">
                        <div className="add-owner-btn mt-3 mb-4">
                          <button
                            type="button"
                            className="btn btn-primary owner-btn rounded-0"
                            onClick={handleAddOwner}
                          >
                            {agreementMailPages?.addOwners.addBtn}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <p>{agreementMailPages?.addOwners.finalText}</p>
                      </div>
                    </div>

                    <div className="step-btn-group d-flex justify-content-center align-items-center mt-5 mb-5 flex-wrap">
                      <div className="prev-btn p-1">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          {submitting
                            ? commonText?.fallbackLoader
                            : buttonName.submit}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default OtherOwners;
